/*** legacy keys ***/
export const LEGACY_SET_PASSWORD_TOKEN_PARAMETER_KEY = 'rm';
export const LEGACY_CHANGE_EMAIL_TOKEN_PARAMETER_KEY = 'LinkId';
export const LEGACY_SERVICE_REDIRECT_TOKEN_PARAMETER_KEY = 'service';

/*** query params ***/
export const REFERRAL_QUERY_PARAMETER_KEY = 'referral';
export const RETURN_URL_KEY = 'returnUrl';
export const SET_PASSWORD_TOKEN_PARAMETER_KEY = 'token';
export const CHANGE_EMAIL_TOKEN_PARAMETER_KEY = 'token';
export const LOGIN_ATTEMPT_ID = 'login_attempt_id';
export const VERIFICATION_CODE = 'verification_code';
export const PROMO_CODE = 'promocode';

export const NO_DISCOUNT_VALUE_COOKIE = 'IMMEDIATESTART';

/*** enums ***/
export enum LegacyRedirectServicesEnum {
  provisioning = 'provisioning',
  billing = 'billing',
}

export enum GrantTypeEnum {
  facebook = 'facebook',
  google = 'google',
  apple = 'apple',
  password = 'password',
  refresh_token = 'refresh_token',
  verification_challenge = 'verification_challenge',
}

export enum ScopeEnum {
  offline_access = 'offline_access',
  read = 'read',
  write = 'write',
}

/*** interfaces ***/
export interface IAccountResponseError {
  description?: string;
  code?: string;
}

export interface ISetPasswordToken {
  value: string;
  email: string;
  userId: string;
}

export interface IChangeEmailToken {
  value: string;
}

/**
 * Returned data from Apple for Apple sign-in
 */
export interface IAppleIdData {
  authorization: {
    state: string;
    code: string;
    id_token: string;
  };

  user?: {
    // user is only returned once by Apple, when user first time authorized
    email: string;
    name: {
      firstName: string;
      lastName: string;
    };
  };
}

export enum IChallengeReasonsEnum {
  email_mfa = 'email_mfa',
  unusual_activity = 'unusual_activity',
}
